import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogMeetingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogMeeting",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.43 9.69h-1.84V7.85c0-.61-.49-1.1-1.1-1.1s-1.1.49-1.1 1.1v1.84h-5.88V7.85c0-.61-.49-1.1-1.1-1.1s-1.1.49-1.1 1.1v1.84h-1.84c-1.42 0-2.57 1.16-2.57 2.57v13.27a2.57 2.57 0 0 0 2.57 2.57h10.3c.3 0 .57-.12.77-.32l5.15-5.15c.19-.2.32-.46.32-.76v-9.6c0-1.42-1.15-2.57-2.56-2.57h-.02Zm.36 11.68-.1.1h-2.85c-.81 0-1.47.66-1.47 1.47v2.85l-.1.1h-9.83c-.19 0-.34-.15-.36-.33v-9.98h14.7v5.8Zm-12.5 3.11h1.47c.42 0 .77-.34.77-.77v-5.92a.77.77 0 0 0-.76-.74H15.3a.77.77 0 0 0-.77.77v5.88c0 .42.34.77.77.77Zm4.39 0h1.53c.42 0 .77-.34.77-.77v-5.92a.77.77 0 0 0-.76-.74h-1.53a.77.77 0 0 0-.77.77v5.88c0 .42.34.77.77.77Zm4.45-7.42h1.47c.41 0 .74.33.74.74v1.47c0 .41-.33.74-.74.74h-1.47c-.41 0-.74-.33-.74-.74V17.8c0-.41.33-.74.74-.74M9.79 7.27H7.5v-2.3c0-.6-.48-1.08-1.08-1.08s-1.08.48-1.08 1.08v2.29H3.06c-.6 0-1.08.48-1.08 1.08s.48 1.08 1.08 1.08h2.29v2.3c0 .6.48 1.08 1.08 1.08s1.08-.48 1.08-1.08V9.43H9.8c.6 0 1.08-.48 1.08-1.08S10.4 7.27 9.8 7.27Z"
    })
  }));
};